<script lang="ts">
	export let data;
</script>

<svelte:component this={data.content} />
